/**
 * @packageDocumentation
 * @module f1/is
 */

export interface IsJson {
  /**
   * Is a JSON object
   *
   * @public
   * @function f1.is.json
   * @example
   *
   * ```ts
   * f1.is.json([]) => true
   * f1.is.json({}) => true
   * f1.is.json({ v: [] }) => true
   * f1.is.json({ v: new Date() }) => false
   * ```
   */
  (value: unknown): value is JSON;
}

/**
 * @see IsJson
 */
export default (value: unknown): value is JSON => {
  try {
    JSON.parse(`${value}`);
    return true;
  } catch {
    return false;
  }
};
